import i18n from '@/plugins/i18n';

export default {
  computed: {
    darkOrLightMode() {
      return { light: this.mode === 'light', dark: this.mode === 'dark' };
    },
  },
  methods: {
    translateLabelIfExist(field) {
      return (this.$te(field.label) ? this.$t(field.label) : field.label) + (field.required ? '*' : '');
    },
    translateIfExist(message) {
      return this.$te(message) ? this.$t(message) : message;
    },
    getFieldRules({ field, required = false }) {
      const rules = [];
      if (required) {
        rules.push((value) => (value !== '' && value != undefined) || i18n.t('field.required'));
      }
      if (field !== undefined) {
        const { min, max, minlength, maxlength, minError, maxError } = field.field_options;
        if (min !== undefined) {
          rules.push((value) => Number(value || 0) >= Number(min) || minError || i18n.t('field.min', { min }));
        }
        if (max) {
          //console.debug('------- max=', max);
          rules.push((value) => Number(value || 0) <= Number(max) || maxError || i18n.t('field.max', { max }));
        }
        if (minlength !== undefined) {
          rules.push((value) => (value || '').length >= minlength || i18n.t('field.minLength', { min: minlength }));
        }
        if (maxlength !== undefined) {
          rules.push((value) => (value || '').length <= maxlength || i18n.t('field.maxLength', { max: maxlength }));
        }
        if (field.field_type === 'email') {
          rules.push((value) => {
            if (value != undefined && value.length > 0) {
              const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || i18n.t('field.invalidEmail');
            } else {
              return true;
            }
          });
        }
      }

      return rules;
    },
    getSize(size) {
      switch (size) {
        case 'large':
          return { maxWidth: '500px', width: '100%' };
        case 'medium':
          return { width: '50%' };
        case 'small':
          return { maxWidth: '500px', width: '100%' };
        default:
          return { maxWidth: '500px', width: '100%' };
      }
    },
    getHeight(size) {
      switch (size) {
        case 'large':
          return 75;
        case 'medium':
          return 50;
        case 'small':
          return 25;
        default:
          return 50;
      }
    },
  },
};
